import Photo1 from '#/photos/memories/frame-1.jpg';
import Photo1Mobile from '#/photos/memories/frame-1-mobile.jpg';
import Photo2 from '#/photos/memories/frame-2.png';
import Photo2Mobile from '#/photos/memories/frame-2-mobile.jpg';
import Photo3 from '#/photos/memories/frame-3.jpg';
import Photo3Mobile from '#/photos/memories/frame-3-mobile.jpg';
import Photo4 from '#/photos/memories/frame-4.jpg';
import Photo4Mobile from '#/photos/memories/frame-4-mobile.jpg';
import Photo5 from '#/photos/memories/frame-5.jpg';
import Photo5Mobile from '#/photos/memories/frame-5-mobile.jpg';
import Photo6 from '#/photos/memories/frame-6.png';
import Photo6Mobile from '#/photos/memories/frame-6-mobile.jpg';
import Photo7 from '#/photos/memories/frame-7.jpg';
import Photo7Mobile from '#/photos/memories/frame-7-mobile.jpg';
import Photo8 from '#/photos/memories/frame-8.jpg';
import Photo8Mobile from '#/photos/memories/frame-8-mobile.jpg';
import Photo9 from '#/photos/memories/frame-9.png';
import Photo9Mobile from '#/photos/memories/frame-9-mobile.jpg';
import Photo10 from '#/photos/memories/frame-10.png';
import Photo10Mobile from '#/photos/memories/frame-10-mobile.jpg';

export const getPhotos = ({ mobile }) => [
  { id: 0, y: 0.3, x: 0.2, url: mobile ? Photo1 : Photo1 },
  { id: 1, y: 0.5, x: 0.4, url: mobile ? Photo2Mobile : Photo2 },
  { id: 2, y: 0.23, x: 0.6, url: mobile ? Photo3 : Photo3 },
  { id: 3, y: 0.6, x: 0.8, url: mobile ? Photo4 : Photo4 },
  { id: 4, y: 0.39, x: 0.6, url: mobile ? Photo5 : Photo5 },
  { id: 5, y: 0.72, x: 0.3, url: mobile ? Photo6Mobile : Photo6 },
  { id: 6, y: 0.34, x: 0.7, url: mobile ? Photo7 : Photo7 },
  { id: 7, y: 0.41, x: 0.7, url: mobile ? Photo8 : Photo8 },
  { id: 8, y: 0.65, x: 0.3, url: mobile ? Photo9Mobile : Photo9 },
  { id: 9, y: 0.22, x: 0.4, url: mobile ? Photo10Mobile : Photo10 },
];
